module.exports = __webpack_public_path__ + "static/promo3-ecf8289f116cc66835d24eee90fbf02f.gif";